<template>
  <div class="audio-player">
    <audio-visualizer :frequencies="frequencies" :bar-color="barColor" />
    <audio
      ref="player"
      :src="src"
      controls="true"
      controlslist="nodownload"
      @playing="startViz"
      @pause="stopViz"
      @ended="stopViz"
    />
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import AudioVisualizer from 'vuecomponents/audio_visualizer'

export default {
  components: { AudioVisualizer },
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      frequencies: [],
      playing: false,
    }
  },
  computed: {
    barColor() {
      if (this.playing) {
        return '#7E57C2'
      }
      return '#E3E3E3'
    },
  },
  mounted() {
    const player = this.$refs.player
    const AudioContext = window.AudioContext || window.webkitAudioContext
    const audioContext = new AudioContext()
    const source = audioContext.createMediaElementSource(player)
    const analyser = audioContext.createAnalyser()
    analyser.fftSize = 256
    source.connect(analyser)
    analyser.connect(audioContext.destination)
    this._analyser = analyser
    this._audioContext = audioContext
  },
  beforeDestroy() {
    if (this._audioContext) {
      this._audioContext.close()
    }
  },
  methods: {
    stopViz() {
      this.playing = false
      clearInterval(this._interval)
    },
    startViz() {
      this.playing = true
      this._interval = setInterval(() => {
        const tempArray = new Uint8Array(128)
        this._analyser.getByteFrequencyData(tempArray)
        this.frequencies = Array.from(tempArray)
      }, 32)
    },
  },
}
</script>

<style lang="scss" scoped>
.audio-player {
  position: relative;
}
canvas {
  display: block;
}
audio {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
